import { ViewModel,View, ObservableArray } from "binder"
import  { ImageChooserView } from "./imageChooser-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { FileChooser, stringIsNullOrEmpty } from "src/common/utilities";
import { Converters } from "src/converters";

export class ImageChooserViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.files = ObservableArray.create<singleFile>();
    }
    GetDefaultView(): View <ViewModel> {
        return new ImageChooserView();
    }
    public getTypeId(): string {
        return "VM-06058C13-86BD-4480-9D59-E72BB8558AB1"
    }

    public set files(v: ObservableArray<singleFile>) { this._files = v; } public get files(): ObservableArray<singleFile> { return this._files;} private _files: ObservableArray<singleFile>;
    public set capturedPicture(v: string) { 
        this._capturedPicture = v; 
        if(stringIsNullOrEmpty(v)==false){
            let newFile = new singleFile(this);
            
            newFile.content = v;
            newFile.name = '1.png';
            newFile.path = new Converters().b64ToSrcConverter(v);
            this.files.push(newFile);
        }
    } public get capturedPicture(): string { return this._capturedPicture;} private _capturedPicture: string;
    

    closePopup(result?: any) {
    }

    loadFiles(...files:singleFile[]){
        this.files.update(...files.map(x=>{
            let r = new singleFile(this);
            r.content = x.content;
            r.name = x.name;
            r.path = new Converters().b64ToSrcConverter(x.content);
            return r;
        }));
    }
    removeFile(file:singleFile){
        this.files.remove(file);
    }

    async addFile(){
        let choosedFile =await new FileChooser().chooseFile();
        if(choosedFile.isChoosed){
            let newFile = new singleFile(this);
            
            newFile.content = choosedFile.fileContent;
            newFile.name = choosedFile.filename;
            newFile.path = new Converters().b64ToSrcConverter(choosedFile.fileContent);
            this.files.push(newFile);
        }
    }

    save(){
        this.closePopup([...this.files]);
    }
    back(){
        this.closePopup(null);
    }
}


export class singleFile extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ImageChooserViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent:ImageChooserViewModel;

    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set path(v: string) { this._path = v; } public get path(): string { return this._path;} private _path: string;
    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    
    remove(){
        this._typedParent.removeFile(this);
    }

    open(){
        window.open(this.path,'_blank');
    }
}